export const C4C_CORONA_TRIAL = 'C4C_CORONA_TRIAL';
export const C4WR_CORONA_TRIAL = 'C4WR_CORONA_TRIAL';
export const C4C_UPSWELL = 'C4C_UPSWELL';
export const COURSERA_CORE = 'COURSERA_CORE';
export const C4C_FREEMIUM = 'C4C_FREEMIUM';
export const GWG_FREEMIUM = ['GWG_CC', 'GWG_ENTERPRISE', 'GWG_SMB'];
